import { IFormHelperProps } from 'telia-front-react';

export const ERRORED_HELPER_FIELD_ID_SUFFIX = '-invalid';
export const COUNTRY_CALLING_CODE_ID = 'countryCallingCode';
export const DATE_AND_TIME_ID = 'dateAndTime';
export const EMAIL_FIELD_ID = 'emailAddress';
export const NAME_FIELD_ID = 'name';
export const PHONE_FIELD_ID = 'phoneNumber';
export const TOPIC_FIELD_ID = 'topic';
export const BRANCH_FIELD_ID = 'branch';

export const getErroredHelperId = (fieldId: string) => fieldId + ERRORED_HELPER_FIELD_ID_SUFFIX;

const baseFieldHelper = (
  translate: (key: string) => string,
  value: string | null,
  dirty: boolean,
  callback?: () => any,
  fieldId?: string
): IFormHelperProps | undefined => {
  if (!dirty) {
    return undefined;
  }
  if (!value) {
    return { type: 'error', text: translate('error.emptyMandatoryField'), id: fieldId ? getErroredHelperId(fieldId) : undefined };
  }
  if (callback) {
    return callback();
  }
  return undefined;
};

export const notEmptyFieldHelper = (
  translate: (key: string) => string,
  value: string | null,
  dirty: boolean,
  fieldId?: string
): IFormHelperProps | undefined => {
  return baseFieldHelper(translate, value, dirty, undefined, fieldId);
};

export const emailFieldHelper = (translate: (key: string) => string, value: string, dirty: boolean): IFormHelperProps | undefined => {
  return baseFieldHelper(
    translate,
    value,
    dirty,
    () => {
      if (!isEmailValid(value)) {
        return { type: 'error', text: translate('email.invalid.format'), id: getErroredHelperId(EMAIL_FIELD_ID) };
      }
    },
    EMAIL_FIELD_ID
  );
};

export const phoneFieldHelper = (translate: (key: string) => string, value: string, dirty: boolean): IFormHelperProps | undefined => {
  return baseFieldHelper(
    translate,
    value,
    dirty,
    () => {
      if (!isPhoneValid(value.replace('+', ''))) {
        return { type: 'error', text: translate('phone.invalid.format'), id: getErroredHelperId(PHONE_FIELD_ID) };
      }
    },
    PHONE_FIELD_ID
  );
};

export const countryCallingCodeFieldHelper = (translate: (key: string) => string, value: string, dirty: boolean): IFormHelperProps | undefined => {
  return baseFieldHelper(
    translate,
    value,
    dirty,
    () => {
      if (!isValidCallingCode(value)) {
        return { type: 'error', text: translate('countryCallingCode.invalid.format'), id: getErroredHelperId(COUNTRY_CALLING_CODE_ID) };
      }
    },
    COUNTRY_CALLING_CODE_ID
  );
};

export const helperInErrorState = (helper: IFormHelperProps | undefined) => {
  return !!(helper && helper.type === 'error');
};

export const isEmailValid = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isPhoneValid = (phone: string) => {
  return /^\d{7,15}$/.test(phone);
};

export const isValidCallingCode = (callingCode: string): boolean => {
  return /^\+\d{1,3}$/.test(callingCode);
};
